import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";

import { useTranslation } from 'react-i18next';
export default function ProductCard({ product, featured = false, microcopy = null }) {
  const { t } = useTranslation();

  const title = product.card_title || product.name;
  const cta = product.cta_label || "Get Access";

  return (
    <Link
      to={`/products/${product.product_id}`}
      data-testid={`product-card-${product.product_id}`}
      className={`relative block bg-zinc-950 border ${
        featured ? "border-amber-500" : "border-zinc-900 hover:border-zinc-700"
      } p-8 flex flex-col transition-colors`}
    >
      {product.badge && (
        <div className="absolute -top-px right-8 bg-amber-500 text-black px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em]">
          {product.badge}
        </div>
      )}
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400 mb-3" aria-hidden="true">
        // {product.product_id}
      </div>
      <h3 className="font-display text-3xl text-white uppercase leading-tight">{title}</h3>
      <p className="text-zinc-400 mt-2 text-sm leading-relaxed min-h-[44px]">{product.tagline}</p>

      <div className="my-6 border-t border-b border-zinc-900 py-6">
        <div className="flex items-baseline gap-2">
          <span className="font-display text-4xl text-white">
            {product.from_price ? `From $${Number(product.price).toFixed(0)}/${product.billing}` : `$${Number(product.price).toFixed(0)}`}
          </span>
          {!product.from_price && (
            <span className="font-mono text-xs text-zinc-400 uppercase tracking-wider">
              {product.billing}
            </span>
          )}
        </div>
        {typeof product.setup_fee === "number" && (
          <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400">
            Setup {product.setup_fee === 0 ? "starts at $0" : `$${Number(product.setup_fee).toFixed(0)}`}
          </div>
        )}
      </div>

      <ul className="space-y-3 flex-1" role="list">
        {(product.features || []).map((f, i) => (
          <li key={i} className="flex gap-3 text-sm text-zinc-300">
            <Check className="w-4 h-4 text-amber-500 mt-0.5 shrink-0" aria-hidden="true" />
            <span>{f}</span>
          </li>
        ))}
      </ul>

      <button
        type="button"
        data-testid={`buy-${product.product_id}-button`}
        className={`mt-8 group flex items-center justify-between px-6 py-4 font-bold uppercase tracking-wider text-xs transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-950 ${
          featured
            ? "bg-amber-500 hover:bg-amber-400 text-black hover:scale-105 hover:shadow-[0_0_20px_rgba(245,158,11,0.3)]"
            : "bg-white text-black hover:bg-amber-500 hover:scale-105"
        }`}
      >
        <span className="text-left">{cta}</span>
        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform shrink-0 ml-2" aria-hidden="true" />
      </button>
      {microcopy && (
        <p className="mt-3 font-mono text-[9px] uppercase tracking-wider text-zinc-500">
          {microcopy}
        </p>
      )}
    </Link>
  );
}
